import _asyncIterator from "@babel/runtime/helpers/asyncIterator";
/* eslint-disable no-mixed-operators */
/* eslint-disable no-restricted-syntax */
/* eslint-disable eqeqeq */
/* eslint-disable no-plusplus */
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
// Modified by lyonlv
import { splitPath } from '@tencent/data-schema-core/lib/utils/path';
import * as CodeMirror from 'codemirror';
import { Pos } from 'codemirror';
import { getJSState, getUnfinishedDataPathAt } from './js-token';
import * as style from "./uicore-expr-input-hint.module.css";
import { getHintDescriptionBox } from './getHintDescriptionBox';
// const stringProps = (
//   'charAt charCodeAt indexOf lastIndexOf substring substr slice trim trimLeft trimRight '
//   + 'toUpperCase toLowerCase split concat match replace search'
// ).split(' ');
// const arrayProps = (
//   'length concat join splice push pop shift unshift slice reverse sort indexOf '
//   + 'lastIndexOf every some filter forEach map reduce reduceRight '
// ).split(' ');
// const keywords = (
//   'break case catch class const continue debugger default delete do else export extends false finally for function '
//   + 'if in import instanceof new null return super switch this throw true try typeof var void while with yield'
// ).split(' ');
export async function uicoreExprInputHint(editor, options) {
  const pos = editor.getCursor();
  const tokenType = editor.getTokenTypeAt(pos);
  const mode = editor.getMode();
  if (String(mode.name).startsWith('interopable-') && !(tokenType !== null && tokenType !== void 0 && tokenType.includes('interopPart'))) {
    var _options$getCompletio;
    const completionIter = (_options$getCompletio = options.getCompletionProvider) === null || _options$getCompletio === void 0 || (_options$getCompletio = _options$getCompletio.call(options)) === null || _options$getCompletio === void 0 ? void 0 : _options$getCompletio.getCompletionsForRaw({
      cm: editor,
      cursor: pos
    });
    const list = [];
    if (completionIter) {
      var _iteratorAbruptCompletion = false;
      var _didIteratorError = false;
      var _iteratorError;
      try {
        for (var _iterator = _asyncIterator(completionIter), _step; _iteratorAbruptCompletion = !(_step = await _iterator.next()).done; _iteratorAbruptCompletion = false) {
          const item = _step.value;
          {
            list.push(item);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (_iteratorAbruptCompletion && _iterator.return != null) {
            await _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
    return {
      list,
      from: pos,
      to: pos
    };
  }
  return await uicoreJavascriptHint(editor, options);
}
const hideDescription = () => {
  getHintDescriptionBox().hide();
  return null;
};
export function getPathForCompletion(editor, cur) {
  // 找到当前的 token
  const token = editor.getTokenAt(cur);
  if (/\b(?:string|comment)\b/.test(token.type)) return null;
  const jsState = getJSState(token);
  if (!jsState) return null;
  // -------------------------------------------------
  let prevPath = '';
  let blurryPart = '';
  {
    const tmp = getUnfinishedDataPathAt(editor, cur);
    if (!tmp) return hideDescription();
    prevPath = tmp.prevPath;
    blurryPart = tmp.blurryPart;
  }
  const from = Pos(cur.line, cur.ch - blurryPart.length);
  const to = cur;
  return {
    prevPath,
    blurryPart,
    from,
    to
  };
}
export async function uicoreJavascriptHint(editor, options) {
  const info = getPathForCompletion(editor, editor.getCursor());
  if (!info) return hideDescription();
  const {
    blurryPart,
    prevPath,
    from,
    to
  } = info;
  // -------------------------------
  // 接下来就是组装结果
  let list = [];
  const maybeAdd = item => {
    if (!list.some(i => i.text === item.text)) {
      list.push(item);
    }
  };
  try {
    var _options$getCompletio2;
    const completionIter = (_options$getCompletio2 = options.getCompletionProvider) === null || _options$getCompletio2 === void 0 || (_options$getCompletio2 = _options$getCompletio2.call(options)) === null || _options$getCompletio2 === void 0 ? void 0 : _options$getCompletio2.getCompletions({
      path: splitPath(prevPath)
    });
    if (completionIter) {
      var _iteratorAbruptCompletion2 = false;
      var _didIteratorError2 = false;
      var _iteratorError2;
      try {
        for (var _iterator2 = _asyncIterator(completionIter), _step2; _iteratorAbruptCompletion2 = !(_step2 = await _iterator2.next()).done; _iteratorAbruptCompletion2 = false) {
          let item = _step2.value;
          {
            if (item.isMethod) item = {
              ...item,
              className: `${style.methodHintItem} ${item.className || ''}`
            };
            maybeAdd(item);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (_iteratorAbruptCompletion2 && _iterator2.return != null) {
            await _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (e) {}
  // -------------------------------
  // 然后，如果需要的话，做模糊匹配过滤
  if (blurryPart) {
    const blurryKeyword = blurryPart.toLowerCase();
    list = list.filter(x => x.text.toLowerCase().includes(blurryKeyword));
  }
  if (!prevPath && !blurryPart && list.length > 0) {
    // 对于凭空开启的补全，默认不能选中任何东西。
    // 但是 codemirror 不支持，所以我们做一个假的补全项目
    list.unshift({
      text: '',
      isDumbPlaceholder: true,
      className: style.dumbHintItem
    });
  }
  if (!list.length) return hideDescription();
  const finalResult = {
    list,
    from,
    to
  };
  CodeMirror.on(finalResult, 'pick', data => {
    if (data.isDumbPlaceholder) {
      const {
        key
      } = window.event;
      let finTxt = '';
      if (key === 'Enter') finTxt = '\n';
      if (key === 'Tab') finTxt = '\t';
      editor.replaceSelection(finTxt); // eslint-disable-line no-param-reassign
      return;
    }
    if (data.isBadVarName) {
      const end = {
        ...editor.getCursor()
      };
      const begin = {
        ch: end.ch - data.text.length,
        line: end.line
      };
      const replaceTo = `[${JSON.stringify(data.text)}]`;
      if (editor.getLine(begin.line).charAt(begin.ch - 1) === '.') begin.ch -= 1;
      editor.replaceRange(replaceTo, begin, end);
      editor.setCursor({
        ch: begin.ch + replaceTo.length,
        line: end.line
      });
    }
    if (data.isObject) {
      const pos = {
        ...editor.getCursor()
      };
      editor.replaceRange('.', pos, pos);
      pos.ch += 1;
      editor.setCursor(pos);
      setTimeout(() => {
        editor.showHint();
      }, 100);
    }
    const method = data.isMethod;
    if (method) {
      setTimeout(() => {
        // 会插入个括号，所以要左边移动下
        const pos = editor.getCursor();
        const content = method.arguments.map((x, i) => x.id || `arg${i}`).join(', '); // 括号里的内容，例如 arg0, arg1
        editor.replaceSelection(`(${content})`, 'start');
        if (content) {
          editor.setSelection({
            line: pos.line,
            ch: pos.ch + 1
          }, {
            line: pos.line,
            ch: pos.ch + 1 + content.length
          });
        } else {
          editor.setCursor({
            line: pos.line,
            ch: pos.ch + 2
          });
        }
      }, 100);
    }
  });
  CodeMirror.on(finalResult, 'close', () => getHintDescriptionBox().hide());
  CodeMirror.on(finalResult, 'select', (data, element) => {
    var _schema$ucHandleAuto;
    if (!data.isDumbPlaceholder) {
      getHintDescriptionBox().show(data, element);
    }
    const schema = data.dataSchema;
    schema === null || schema === void 0 || (_schema$ucHandleAuto = schema['uc:handleAutoComplete']) === null || _schema$ucHandleAuto === void 0 || _schema$ucHandleAuto.call(schema, 'active', schema);
  });
  return finalResult;
}
//# sourceMappingURL=uicore-expr-input-hint.js.map
